!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports) : "function" == typeof define && define.amd ? define(["exports"], e) : e((t = t || self).window = t.window || {});
}(this, function (t) {
  "use strict";

  var _r = function r(t, e) {
    return (_r = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var r in e) {
        e.hasOwnProperty(r) && (t[r] = e[r]);
      }
    })(t, e);
  };

  var _s = function s() {
    return (_s = Object.assign || function (t) {
      for (var e, r = 1, n = arguments.length; r < n; r++) {
        for (var i in e = arguments[r]) {
          Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
        }
      }

      return t;
    }).apply(this, arguments);
  },
      h = "0123456789bcdefghjkmnpqrstuvwxyz",
      d = 5,
      i = .00669447819799,
      o = 6378137,
      a = 40007860,
      u = 1e-12,
      f = 10,
      c = 22 * d,
      l = 110574;

  function p(t, e) {
    var r = e / l,
        n = Math.min(90, t.latitude + r),
        i = Math.max(-90, t.latitude - r),
        o = 2 * Math.floor(function (t) {
      return Math.min(q(a / 2 / t), c);
    }(e)),
        u = 2 * Math.floor(O(e, n)) - 1,
        s = 2 * Math.floor(O(e, i)) - 1;
    return Math.min(o, u, s, c);
  }

  function _(t, e) {
    S(t), S(e);
    var r = y(e.latitude - t.latitude),
        n = y(e.longitude - t.longitude),
        i = Math.sin(r / 2) * Math.sin(r / 2) + Math.cos(y(t.latitude)) * Math.cos(y(e.latitude)) * Math.sin(n / 2) * Math.sin(n / 2);
    return 6371 * (2 * Math.atan2(Math.sqrt(i), Math.sqrt(1 - i)));
  }

  function y(t) {
    if ("number" != typeof t || isNaN(t)) throw new Error("Error: degrees must be a number");
    return t * Math.PI / 180;
  }

  function m(t, e) {
    if (void 0 === e && (e = f), S(t), "number" != typeof e || isNaN(e)) throw new Error("precision must be a number");
    if (e <= 0) throw new Error("precision must be greater than 0");
    if (22 < e) throw new Error("precision cannot be greater than 22");
    if (Math.round(e) !== e) throw new Error("precision must be an integer");

    for (var r = {
      min: -90,
      max: 90
    }, n = {
      min: -180,
      max: 180
    }, i = "", o = 0, u = 0, s = 1; i.length < e;) {
      var a = s ? t.longitude : t.latitude,
          c = s ? n : r,
          d = (c.min + c.max) / 2;
      d < a ? (o = 1 + (o << 1), c.min = d) : (o = 0 + (o << 1), c.max = d), s = !s, u < 4 ? u++ : (u = 0, i += h[o], o = 0);
    }

    return i;
  }

  function b(t, e, r) {
    return S(t), C(e), {
      g: e,
      l: t,
      d: r
    };
  }

  function g(t) {
    var e = _s({}, t);

    return delete e.customKey, e;
  }

  function v(t, e) {
    if ("[object Object]" !== Object.prototype.toString.call(t)) throw new Error("document must be an object");
    var r = e ? e.customKey : null,
        n = "d" in t ? t.d : t,
        i = j(n, r, e && (e.merge || !!e.mergeFields));
    return i ? b(i, m(i), n) : {
      d: n
    };
  }

  function w(e, t) {
    if ("[object Object]" !== Object.prototype.toString.call(e)) throw new Error("document must be an object");
    var r = {},
        n = j(e, t, !0);
    return n && (r.l = n, r.g = m(r.l)), Object.getOwnPropertyNames(e).forEach(function (t) {
      r["d." + t] = e[t];
    }), r;
  }

  function j(t, e, r) {
    var n, i;
    if (void 0 === r && (r = !1), e) {
      if (e in t) i = t[e];else {
        i = t;

        for (var o = 0, u = e.split("."); o < u.length; o++) {
          var s = u[o];

          if (!(s in i)) {
            i = t.coordinates;
            break;
          }

          i = i[s];
        }
      }
    } else i = t.coordinates;
    if (i || (n = "could not find GeoPoint"), i && !S(i, !0) && (n = "invalid GeoPoint"), n && !r) throw new Error("Invalid GeoFirestore document: " + n);
    return i;
  }

  function n(t, e) {
    var r = function (t, e) {
      return M(t, !0) ? {
        data: function data() {
          return t.d;
        },
        distance: e ? _(t.l, e) : null
      } : {
        data: function data() {
          return t;
        },
        distance: null
      };
    }(t.data(), e);

    return _s({
      exists: t.exists,
      id: t.id
    }, r);
  }

  function e(t, e) {
    S(t);

    var r = Math.max(1, p(t, e)),
        n = Math.ceil(r / d),
        i = function (t, e) {
      var r = e / l,
          n = Math.min(90, t.latitude + r),
          i = Math.max(-90, t.latitude - r),
          o = E(e, n),
          u = E(e, i),
          s = Math.max(o, u);
      return [x(t.latitude, t.longitude), x(t.latitude, R(t.longitude - s)), x(t.latitude, R(t.longitude + s)), x(n, t.longitude), x(n, R(t.longitude - s)), x(n, R(t.longitude + s)), x(i, t.longitude), x(i, R(t.longitude - s)), x(i, R(t.longitude + s))];
    }(t, e).map(function (t) {
      return function (t, e) {
        C(t);
        var r = Math.ceil(e / d);
        if (t.length < r) return [t, t + "~"];
        var n = t.substring(0, r),
            i = n.substring(0, n.length - 1),
            o = h.indexOf(n.charAt(n.length - 1)),
            u = e - i.length * d,
            s = d - u,
            a = o >> s << s,
            c = a + (1 << s);
        return 31 < c ? [i + h[a], i + "~"] : [i + h[a], i + h[c]];
      }(m(t, n), r);
    });

    return i.filter(function (r, n) {
      return !i.some(function (t, e) {
        return e < n && r[0] === t[0] && r[1] === t[1];
      });
    });
  }

  function q(t) {
    return Math.log(t) / Math.log(2);
  }

  function O(t, e) {
    var r = E(t, e);
    return 1e-6 < Math.abs(r) ? Math.max(1, q(360 / r)) : 1;
  }

  function E(t, e) {
    var r = y(e),
        n = Math.cos(r) * o * Math.PI / 180 * (1 / Math.sqrt(1 - i * Math.sin(r) * Math.sin(r)));
    return n < u ? 0 < t ? 360 : 0 : Math.min(360, t / n);
  }

  function x(t, e) {
    var r = {
      latitude: t,
      longitude: e
    };
    return S(r), r;
  }

  function M(t, e) {
    var r;
    if (void 0 === e && (e = !1), r = C(t.g, !0) ? null : "invalid geohash on object", r = S(t.l, !0) ? r : "invalid location on object", t && "d" in t && "object" == typeof t.d || (r = "no valid document found"), r && !e) throw new Error("Invalid GeoFirestore object: " + r);
    return !r;
  }

  function C(t, e) {
    var r;
    if (void 0 === e && (e = !1), "string" != typeof t) r = "geohash must be a string";else if (0 === t.length) r = "geohash cannot be the empty string";else for (var n = 0, i = t; n < i.length; n++) {
      var o = i[n];
      -1 === h.indexOf(o) && (r = "geohash cannot contain '" + o + "'");
    }
    if (void 0 === r || e) return !r;
    throw new Error("Invalid GeoFire geohash '" + t + "': " + r);
  }

  function P(t, e) {
    var r;
    if (void 0 === e && (e = !1), "number" != typeof t || isNaN(t) ? r = "limit must be a number" : t < 0 && (r = "limit must be greater than or equal to 0"), void 0 === r || e) return !r;
    throw new Error(r);
  }

  function S(t, e) {
    var r;
    if (void 0 === e && (e = !1), t) {
      if (void 0 === t.latitude) r = "latitude must exist on GeoPoint";else if (void 0 === t.longitude) r = "longitude must exist on GeoPoint";else {
        var n = t.latitude,
            i = t.longitude;
        "number" != typeof n || isNaN(n) ? r = "latitude must be a number" : n < -90 || 90 < n ? r = "latitude must be within the range [-90, 90]" : "number" != typeof i || isNaN(i) ? r = "longitude must be a number" : (i < -180 || 180 < i) && (r = "longitude must be within the range [-180, 180]");
      }
    } else r = "GeoPoint must exist";
    if (void 0 === r || e) return !r;
    throw new Error("Invalid location: " + r);
  }

  function I(t, e) {
    if (void 0 === e && (e = !1), "object" != typeof t) throw new Error("QueryCriteria must be an object");
    if (void 0 === t.center && void 0 === t.radius) throw new Error("radius and/or center must be specified");
    if (e && (void 0 === t.center || void 0 === t.radius)) throw new Error("QueryCriteria for a new query must contain both a center and a radius");

    for (var r = 0, n = Object.keys(t); r < n.length; r++) {
      var i = n[r];
      if (!["center", "radius", "limit"].includes(i)) throw new Error("Unexpected attribute '" + i + "' found in query criteria");
    }

    if (void 0 !== t.center && S(t.center), void 0 !== t.radius) {
      if ("number" != typeof t.radius || isNaN(t.radius)) throw new Error("radius must be a number");
      if (t.radius < 0) throw new Error("radius must be greater than or equal to 0");
    }

    void 0 !== t.limit && P(t.limit);
  }

  function R(t) {
    if (t <= 180 && -180 <= t) return t;
    var e = t + 180;
    return 0 < e ? e % 360 - 180 : 180 - -e % 360;
  }

  var G = (Object.defineProperty(N.prototype, "exists", {
    get: function get() {
      return this._snapshot.exists;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(N.prototype, "id", {
    get: function get() {
      return this._snapshot.id;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(N.prototype, "ref", {
    get: function get() {
      return new B(this._snapshot.ref);
    },
    enumerable: !0,
    configurable: !0
  }), N.prototype.data = function (t) {
    var e = this._isWeb && t ? this._snapshot.data(t) : this._snapshot.data();
    return e ? function (t) {
      return M(t, !0) ? t.d : t;
    }(e) : null;
  }, N.prototype.get = function (t, e) {
    var r = "d." + t;
    return this._isWeb && e ? this._snapshot.get(r, e) : this._snapshot.get(r);
  }, N.prototype.isEqual = function (t) {
    return t instanceof N ? this._snapshot.isEqual(t._snapshot) : this._snapshot.isEqual(t);
  }, N);

  function N(t) {
    if (this._snapshot = t, "[object Object]" !== Object.prototype.toString.call(t)) throw new Error("DocumentSnapshot must be an instance of a Firestore DocumentSnapshot");
    this._isWeb = "[object Function]" === Object.prototype.toString.call(t.ref.firestore.enablePersistence);
  }

  var F = (A.prototype.set = function (t, e, r) {
    var n = t instanceof B ? t._document : t;
    return this._writeBatch.set(n, v(e, r), g(r)), this;
  }, A.prototype.update = function (t, e, r) {
    var n = t instanceof B ? t._document : t;
    return this._writeBatch.update(n, w(e, r)), this;
  }, A.prototype.delete = function (t) {
    var e = t instanceof B ? t._document : t;
    return this._writeBatch.delete(e), this;
  }, A.prototype.commit = function () {
    return this._writeBatch.commit();
  }, A);

  function A(t) {
    if (this._writeBatch = t, "[object Object]" !== Object.prototype.toString.call(t)) throw new Error("WriteBatch must be an instance of a Firestore WriteBatch");
  }

  var Q = (W.prototype.batch = function () {
    return new F(this._firestore.batch());
  }, W.prototype.collection = function (t) {
    return new Z(this._firestore.collection(t));
  }, W.prototype.runTransaction = function (t) {
    return this._firestore.runTransaction(t);
  }, W);

  function W(t) {
    if (this._firestore = t, "[object Object]" !== Object.prototype.toString.call(t)) throw new Error("Firestore must be an instance of Firestore");
  }

  var B = (Object.defineProperty(T.prototype, "id", {
    get: function get() {
      return this._document.id;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(T.prototype, "firestore", {
    get: function get() {
      return new Q(this._document.firestore);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(T.prototype, "onSnapshot", {
    get: function get() {
      var t = this;
      return function (e, r) {
        return t._document.onSnapshot(function (t) {
          return e(new G(t));
        }, function (t) {
          r && r(t);
        });
      };
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(T.prototype, "parent", {
    get: function get() {
      return new Z(this._document.parent);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(T.prototype, "path", {
    get: function get() {
      return this._document.path;
    },
    enumerable: !0,
    configurable: !0
  }), T.prototype.collection = function (t) {
    return new Z(this._document.collection(t));
  }, T.prototype.delete = function () {
    return this._document.delete().then(function () {
      return null;
    });
  }, T.prototype.get = function (t) {
    return void 0 === t && (t = {
      source: "default"
    }), this._isWeb ? this._document.get(t).then(function (t) {
      return new G(t);
    }) : this._document.get().then(function (t) {
      return new G(t);
    });
  }, T.prototype.isEqual = function (t) {
    return t instanceof T ? this._document.isEqual(t._document) : this._document.isEqual(t);
  }, T.prototype.set = function (t, e) {
    return this._document.set(v(t, e), g(e)).then(function () {
      return null;
    });
  }, T.prototype.update = function (t, e) {
    return this._document.update(w(t, e)).then(function () {
      return null;
    });
  }, T);

  function T(t) {
    if (this._document = t, "[object Object]" !== Object.prototype.toString.call(t)) throw new Error("DocumentReference must be an instance of a Firestore DocumentReference");
    this._isWeb = "[object Function]" === Object.prototype.toString.call(t.firestore.enablePersistence);
  }

  var V = (Object.defineProperty(D.prototype, "docs", {
    get: function get() {
      return this._docs;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(D.prototype, "size", {
    get: function get() {
      return this._docs.length;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(D.prototype, "empty", {
    get: function get() {
      return !this._docs.length;
    },
    enumerable: !0,
    configurable: !0
  }), D.prototype.docChanges = function () {
    var e = this;
    return (Array.isArray(this._querySnapshot.docChanges) ? this._querySnapshot.docChanges : this._querySnapshot.docChanges()).map(function (t) {
      return {
        doc: n(t.doc, e._center),
        newIndex: t.newIndex,
        oldIndex: t.oldIndex,
        type: t.type
      };
    });
  }, D.prototype.forEach = function (t, e) {
    this.docs.forEach(t, e);
  }, D);

  function D(t, e) {
    this._querySnapshot = t, (this._center = e) && S(e), this._docs = t.docs.map(function (t) {
      return n(t, e);
    });
  }

  var z = (k.prototype.getGeoQuerySnapshot = function () {
    var t = Array.from(this._docs.values());
    return new V({
      docs: t,
      docChanges: function docChanges() {
        return t.map(function (t, e) {
          return {
            doc: t,
            newIndex: e,
            oldIndex: -1,
            type: "added"
          };
        });
      }
    }, this._queryCriteria.center);
  }, k);

  function k(t, e) {
    var r = this;
    if (this._queryCriteria = e, this._docs = new Map(), I(e), t.forEach(function (t) {
      t.docs.forEach(function (t) {
        var e = _(r._queryCriteria.center, t.data().l);

        r._queryCriteria.radius >= e && r._docs.set(t.id, t);
      });
    }), this._queryCriteria.limit && this._docs.size > this._queryCriteria.limit) for (var n = Array.from(this._docs.values()).map(function (t) {
      return {
        distance: _(r._queryCriteria.center, t.data().l),
        id: t.id
      };
    }).sort(function (t, e) {
      return t.distance - e.distance;
    }), i = this._queryCriteria.limit; i < n.length; i++) {
      this._docs.delete(n[i].id);
    }
  }

  var K = (U.prototype.unsubscribe = function () {
    var t = this;
    return function () {
      clearInterval(t._interval), t._subscriptions.forEach(function (t) {
        return t();
      });
    };
  }, U.prototype._next = function () {
    var n = this;
    if (this._queryCriteria.limit && this._docs.size > this._queryCriteria.limit) for (var t = Array.from(this._docs.values()).sort(function (t, e) {
      return t.distance - e.distance;
    }), e = this._queryCriteria.limit; e < t.length; e++) {
      if (t[e].emitted) {
        var r = {
          change: _s({}, t[e].change),
          distance: t[e].distance,
          emitted: t[e].emitted
        };
        r.change.type = "removed", this._docs.set(r.change.doc.id, r);
      } else this._docs.delete(t[e].change.doc.id);
    }
    var i = 0,
        o = Array.from(this._docs.values()).map(function (t, e) {
      var r = {
        type: t.change.type,
        doc: t.change.doc,
        oldIndex: t.emitted ? t.change.newIndex : -1,
        newIndex: "removed" !== t.change.type ? e - i : -1
      };
      return "removed" === r.type ? (i--, n._docs.delete(r.doc.id)) : n._docs.set(r.doc.id, {
        change: r,
        distance: t.distance,
        emitted: !0
      }), r;
    }),
        u = o.reduce(function (t, e) {
      return 0 <= e.newIndex ? t.push(e.doc) : n._docs.delete(e.doc.id), t;
    }, []);
    this._firstEmitted = !0, this._onNext(new V({
      docs: u,
      docChanges: function docChanges() {
        return o.reduce(function (t, e) {
          return -1 !== e.oldIndex && "added" === e.type || t.push(e), t;
        }, []);
      }
    }, this._queryCriteria.center));
  }, U.prototype._emit = function () {
    this._error ? (this._onError && this._onError(this._error), this.unsubscribe()()) : this._newValues && this._firstRoundResolved ? (this._newValues = !1, this._next()) : this._firstRoundResolved || (this._firstRoundResolved = this._queriesResolved.reduce(function (t, e) {
      return t + e;
    }, 0) === this._queries.length);
  }, U.prototype._processSnapshot = function (t, e) {
    var o = this,
        r = Array.isArray(t.docChanges) ? t.docChanges : t.docChanges();
    this._firstRoundResolved || (this._queriesResolved[e] = 1), r.length ? r.forEach(function (t) {
      var e = t.doc.data().l ? _(o._queryCriteria.center, t.doc.data().l) : null,
          r = t.doc.id,
          n = o._docs.get(r),
          i = {
        change: {
          doc: t.doc,
          oldIndex: n && o._firstEmitted ? n.change.oldIndex : -1,
          newIndex: n && o._firstEmitted ? n.change.newIndex : -1,
          type: n && o._firstEmitted ? t.type : "added"
        },
        distance: e,
        emitted: !!o._firstEmitted && !!n
      };

      if (o._queryCriteria.radius >= e) {
        if (!n && "removed" === i.change.type) return;
        n || "modified" !== i.change.type || (i.change.type = "added"), o._newValues = !0, o._docs.set(r, i);
      } else n ? (i.change.type = "removed", o._newValues = !0, o._docs.set(r, i)) : n || o._firstRoundResolved || (o._newValues = !0);
    }) : this._firstRoundResolved || (this._newValues = !0);
  }, U);

  function U(t, e, r, n) {
    var i = this;
    this._queries = t, this._queryCriteria = e, this._onNext = r, this._onError = n, this._docs = new Map(), this._firstRoundResolved = !1, this._firstEmitted = !1, this._newValues = !1, this._subscriptions = [], this._queriesResolved = [], I(e), this._queriesResolved = new Array(t.length).fill(0), t.forEach(function (t, e) {
      var r = t.onSnapshot(function (t) {
        return i._processSnapshot(t, e);
      }, function (t) {
        return i._error = t;
      });

      i._subscriptions.push(r);
    }), this._interval = setInterval(function () {
      return i._emit();
    }, 100);
  }

  var H = (Object.defineProperty(J.prototype, "firestore", {
    get: function get() {
      return new Q(this._query.firestore);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(J.prototype, "onSnapshot", {
    get: function get() {
      var r = this;
      return function (e, t) {
        return r._center && r._radius ? new K(r._generateQuery(), r._queryCriteria, e, t).unsubscribe() : (r._limit ? r._query.limit(r._limit) : r._query).onSnapshot(function (t) {
          return e(new V(t));
        }, t);
      };
    },
    enumerable: !0,
    configurable: !0
  }), J.prototype.get = function (e) {
    var r = this;

    if (void 0 === e && (e = {
      source: "default"
    }), this._center && void 0 !== this._radius) {
      var t = this._generateQuery().map(function (t) {
        return r._isWeb ? t.get(e) : t.get();
      });

      return Promise.all(t).then(function (t) {
        return new z(t, r._queryCriteria).getGeoQuerySnapshot();
      });
    }

    var n = this._limit ? this._query.limit(this._limit) : this._query;
    return (this._isWeb ? n.get(e) : n.get()).then(function (t) {
      return new V(t);
    });
  }, J.prototype.limit = function (t) {
    return P(t), this._limit = t, new J(this._query, this._queryCriteria);
  }, J.prototype.near = function (t) {
    return I(t), this._center = t.center || this._center, this._radius = t.radius || this._radius, new J(this._query, this._queryCriteria);
  }, J.prototype.where = function (t, e, r) {
    return new J(this._query.where(t ? "d." + t : t, e, r), this._queryCriteria);
  }, J.prototype._generateQuery = function () {
    var r = this,
        n = e(this._center, 1e3 * this._radius).map(this._queryToString);
    return (n = n.filter(function (t, e) {
      return n.indexOf(t) === e;
    })).map(function (t) {
      var e = r._stringToQuery(t);

      return r._query.orderBy("g").startAt(e[0]).endAt(e[1]);
    });
  }, Object.defineProperty(J.prototype, "_queryCriteria", {
    get: function get() {
      return {
        center: this._center,
        limit: this._limit,
        radius: this._radius
      };
    },
    enumerable: !0,
    configurable: !0
  }), J.prototype._stringToQuery = function (t) {
    var e = t.split(":");
    if (2 !== e.length) throw new Error("Invalid internal state! Not a valid geohash query: " + t);
    return e;
  }, J.prototype._queryToString = function (t) {
    if (2 !== t.length) throw new Error("Not a valid geohash query: " + t);
    return t[0] + ":" + t[1];
  }, J);

  function J(t, e) {
    if (this._query = t, "[object Object]" !== Object.prototype.toString.call(t)) throw new Error("Query must be an instance of a Firestore Query");
    this._isWeb = "[object Function]" === Object.prototype.toString.call(t.firestore.enablePersistence), e && (e.limit && (this._limit = e.limit), e.center && e.radius && (I(e), this._center = e.center, this._radius = e.radius));
  }

  var L,
      X,
      Y,
      Z = (_r(L = tt, X = Y = H), void (L.prototype = null === X ? Object.create(X) : ($.prototype = X.prototype, new $())), Object.defineProperty(tt.prototype, "id", {
    get: function get() {
      return this._collection.id;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(tt.prototype, "parent", {
    get: function get() {
      return this._collection.parent ? new B(this._collection.parent) : null;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(tt.prototype, "path", {
    get: function get() {
      return this._collection.path;
    },
    enumerable: !0,
    configurable: !0
  }), tt.prototype.add = function (t, e) {
    if ("[object Object]" !== Object.prototype.toString.call(t)) throw new Error("document must be an object");
    var r = j(t, e),
        n = m(r);
    return this._collection.add(b(r, n, t)).then(function (t) {
      return new B(t);
    });
  }, tt.prototype.doc = function (t) {
    return new B(t ? this._collection.doc(t) : this._collection.doc());
  }, tt);

  function $() {
    this.constructor = L;
  }

  function tt(t) {
    var e = Y.call(this, t) || this;
    return e._collection = t, e;
  }

  var et = (rt.prototype.delete = function (t) {
    var e = t instanceof B ? t._document : t;
    return this._transaction.delete(e), this;
  }, rt.prototype.get = function (t) {
    var e = t instanceof B ? t._document : t;
    return this._transaction.get(e).then(function (t) {
      return new G(t);
    });
  }, rt.prototype.set = function (t, e, r) {
    var n = t instanceof B ? t._document : t;
    return this._transaction.set(n, v(e, r), g(r)), this;
  }, rt.prototype.update = function (t, e, r) {
    var n = t instanceof B ? t._document : t;
    return this._transaction.update(n, w(e, r)), this;
  }, rt);

  function rt(t) {
    if (this._transaction = t, "[object Object]" !== Object.prototype.toString.call(t)) throw new Error("Transaction must be an instance of a Firestore Transaction");
  }

  t.GeoCollectionReference = Z, t.GeoDocumentReference = B, t.GeoDocumentSnapshot = G, t.GeoFirestore = Q, t.GeoQuery = H, t.GeoQuerySnapshot = V, t.GeoTransaction = et, t.GeoWriteBatch = F, Object.defineProperty(t, "__esModule", {
    value: !0
  });
});